import Box from "@mui/material/Box";
import { memo, type PropsWithChildren } from "react";
import { DEFAULT_LAYOUT_CONTENT_ID, DEFAULT_LAYOUT_ID } from "../../../../constants/layouts/default-layout.const";
import useLayoutStylesStore from "../../../../hooks/layout/use-layout-styles-store/useLayoutStylesStore";
import useShowLayoutComponentsStore from "../../../../hooks/layout/use-show-layout-components-store/useShowLayoutComponentsStore";
import BottomNavigationBar from "../../../../legacy/components/BottomNavigationBar/BottomNavigationBar";
import { Chatbot } from "../../../../legacy/components/Chatbot/chatbot";
import { EmptyComponent } from "../../../../legacy/components/common/EmptyComponent";
import HeaderV2 from "../../../../legacy/components/HeaderV2/header-v2";
import MobileAppBannerWrapper from "../../../../legacy/components/MobileAppBanner/mobile-app-banner-wrapper";
import { DefaultLayoutContentContainer } from "./DefaultLayoutContentContainer";

const MOBILE_CONTAINER_STYLE = {
  minHeight: "100vh",
};

export interface DefaultLayoutMobileProps extends PropsWithChildren<{}> {
  isLogoClickable?: boolean;
}

function DefaultLayoutMobile({ children, isLogoClickable = true }: Readonly<DefaultLayoutMobileProps>): JSX.Element {
  const { layoutStyles } = useLayoutStylesStore();
  const { showHeaderStore, showBottomNavigationStore } = useShowLayoutComponentsStore();

  const mobileContainerStyling = { ...MOBILE_CONTAINER_STYLE, ...layoutStyles.layoutStyles?.mobile };

  return (
    <Box id={DEFAULT_LAYOUT_ID} sx={mobileContainerStyling}>
      <MobileAppBannerWrapper />
      {showHeaderStore ? <HeaderV2 isLogoClickable={isLogoClickable} /> : <EmptyComponent />}

      <DefaultLayoutContentContainer
        id={DEFAULT_LAYOUT_CONTENT_ID}
        isMobile
        sx={layoutStyles.contentLayoutStyles?.mobile}
      >
        {children}
      </DefaultLayoutContentContainer>

      {showBottomNavigationStore ? <BottomNavigationBar /> : <EmptyComponent />}

      <Chatbot />
    </Box>
  );
}

export default memo(DefaultLayoutMobile);
